const shuffleArrayWithSalt = (array: any[], salt = Date.now().toString()) => {
    let hash = 0;
    if (salt.length === 0) {
        return hash;
    }
    for (let i = 0; i < salt.length; i++) {
        const char = salt.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }
    let state = hash % 2147483647;
    if (state <= 0) {
        state += 2147483646;
    }

    const randomGenerator = () => {
        state = (state * 16807) % 2147483647;
        return (state - 1) / 2147483646;
    };

    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(randomGenerator() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
};

export default shuffleArrayWithSalt;
